<template>
  <v-card elevation="0" class="all-trade-tab rounded-0 mt-5" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-tabs v-model="model" background-color="transparent">
      <v-tab :href="`#tab-1`">
        Waiting to Start
      </v-tab>
      <v-tab :href="`#tab-2`">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Running Contest
      </v-tab>
      <v-tab :href="`#tab-3`">
        Finished Contest
      </v-tab>
      <v-tabs-items v-model="model">
        <div class="contest-card px-2 mt-5">
          <v-row dense>
            <v-col cols="12" sm="12" md="5" lg="10">
              <v-text-field class="search-field" v-model="search" prepend-icon="mdi-magnify" label="Search here ..."
                single-line solo hide-details>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3" lg="2" class="text-sm-right">
              <add-contest-modal></add-contest-modal>
            </v-col>
          </v-row>
        </div>
        <v-tab-item :value="`tab-1`">
          <v-card class="mt-2" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <pending-contest-tab :allupcomingcontests="allupcomingcontests"
              :allacctypes="allacctypes"></pending-contest-tab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card class="mt-2" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <running-contest-tab :allrunningcontests="allrunningcontests"
              :allacctypes="allacctypes"></running-contest-tab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-3`">
          <v-card class="mt-2" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <finished-contest-tab :allfinishedcontests="allfinishedcontests"
              :allacctypes="allacctypes"></finished-contest-tab>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>
<script>
import FinishedContestTab from './FinishedContestTab.vue';
import PendingContestTab from './PendingContestTab.vue';
import RunningContestTab from './RunningContestTab.vue';
import AddContestModal from './AddContestModal.vue';
import { CONTEST__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    AddContestModal,
    PendingContestTab,
    RunningContestTab,
    FinishedContestTab,
  },
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  computed: {
    ...mapState("contest", ["allupcomingcontests", "allrunningcontests", "allfinishedcontests", "allacctypes"]),
  },
  methods: {
    ...mapActions("contest", [CONTEST__ACTIONS.GETALLFINISHEDCONTEST, CONTEST__ACTIONS.GETALLRUNNINGCONTEST, CONTEST__ACTIONS.GETALLUPCOMINGCONTEST, CONTEST__ACTIONS.GETALLCONTESTACCTYPES]),
  },
  async mounted() {
    await this[CONTEST__ACTIONS.GETALLCONTESTACCTYPES]();
    await this[CONTEST__ACTIONS.GETALLUPCOMINGCONTEST]();
    await this[CONTEST__ACTIONS.GETALLRUNNINGCONTEST]();
    await this[CONTEST__ACTIONS.GETALLFINISHEDCONTEST]();
  }
};
</script>
